import React, { useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import gtag from 'ga-gtag';

// Components
import Navbar from 'components/Navbar';
import DashboardBanner from 'components/DashboardBanner';
import Footer from 'components/Footer';
// import SalesCard from 'components/SalesCard';
import MyProperties from './MyProperties';
import MyWishlist from './MyWishlist';
import UserProfile from './UserProfile';

// Style
import './UserDashboardPageStyle.css';

const mapTabToWishList = {
  wishlist: 'MyWishlist',
};

const UserDashboardPage = () => {
  const [setActive, setActiveState] = useState('MyProperties');
  const location = useLocation();

  const trackDashboardPage = () => {
    gtag('event', 'opened_dashboard', {
      method: 'user_logged_in',
    });
  };

  React.useEffect(() => {
    trackDashboardPage();
    const search = new URLSearchParams(location.search).get('view');
    if (search) {
      setActiveState(mapTabToWishList[search]);
    }
  }, [location.search]);

  const history = useHistory();

  const toggleTab = (event) => {
    const { value } = event.currentTarget.dataset;
    history.push(location.pathname);
    setActiveState(() => value);
  };

  return (
    <section className="userdashboardpage">
      <Navbar />
      <DashboardBanner />
      <div className="container">
        <div className="userdashboardpage-menu">
          <div className="row">
            <div className="col-md-2">
              <div className="buttonTab">
                <button
                  type="button"
                  className={`btn btn-xlarge ${
                    setActive === 'MyProperties' && 'active'
                  }`}
                  onClick={toggleTab}
                  id="MyProperties"
                  data-value="MyProperties"
                >
                  <span>
                    <svg
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M39.0001 17.32C38.9988 17.3191 38.9979 17.3178 38.997 17.3169L22.6801 1.00067C21.9846 0.304871 21.06 -0.078125 20.0764 -0.078125C19.0928 -0.078125 18.1681 0.304871 17.4723 1.00067L1.16398 17.3087C1.15849 17.3142 1.15269 17.32 1.1475 17.3255C-0.280721 18.7619 -0.27828 21.0926 1.15452 22.5254C1.80913 23.1803 2.67339 23.5593 3.59777 23.5993C3.63561 23.603 3.67345 23.6048 3.7116 23.6048H4.36162V35.6123C4.36162 37.9887 6.29522 39.922 8.67163 39.922H15.0553C15.7026 39.922 16.2272 39.3971 16.2272 38.7501V29.336C16.2272 28.2517 17.1094 27.3697 18.1937 27.3697H21.959C23.0433 27.3697 23.9253 28.2517 23.9253 29.336V38.7501C23.9253 39.3971 24.4499 39.922 25.0971 39.922H31.4808C33.8575 39.922 35.7908 37.9887 35.7908 35.6123V23.6048H36.3938C37.3771 23.6048 38.3018 23.2218 38.9979 22.5257C40.4322 21.0907 40.4329 18.7558 39.0001 17.32ZM37.3405 20.8686C37.0875 21.1216 36.7512 21.261 36.3938 21.261H34.6189C33.9717 21.261 33.4471 21.7856 33.4471 22.4329V35.6123C33.4471 36.6962 32.5651 37.5782 31.4808 37.5782H26.269V29.336C26.269 26.9596 24.3357 25.026 21.959 25.026H18.1937C15.817 25.026 13.8834 26.9596 13.8834 29.336V37.5782H8.67163C7.58764 37.5782 6.70538 36.6962 6.70538 35.6123V22.4329C6.70538 21.7856 6.18078 21.261 5.5335 21.261H3.78911C3.7708 21.2598 3.75279 21.2589 3.73418 21.2586C3.38506 21.2525 3.0576 21.1139 2.81224 20.8683C2.29039 20.3464 2.29039 19.4971 2.81224 18.975C2.81255 18.975 2.81255 18.9746 2.81285 18.9743L2.81377 18.9734L19.13 2.65778C19.3827 2.40479 19.7187 2.26563 20.0764 2.26563C20.4337 2.26563 20.7697 2.40479 21.0227 2.65778L37.3353 18.9701C37.3378 18.9725 37.3405 18.975 37.3429 18.9774C37.8621 19.5002 37.8611 20.3476 37.3405 20.8686Z"
                        fill="#131516"
                      />
                    </svg>
                  </span>
                  My Properties
                </button>
              </div>
            </div>
            <div className="col-md-2">
              <div className="buttonTab">
                <button
                  type="button"
                  className={`btn btn-xlarge ${
                    setActive === 'MyWishlist' && 'active'
                  }`}
                  onClick={toggleTab}
                  id="MyWishlist"
                  data-value="MyWishlist"
                >
                  <span>
                    <svg
                      width="40"
                      height="36"
                      viewBox="0 0 40 36"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M20 35.7746C19.4305 35.7746 18.8815 35.5683 18.4536 35.1935C16.8377 33.7806 15.2798 32.4528 13.9053 31.2815L13.8983 31.2754C9.86845 27.8413 6.38854 24.8756 3.96728 21.9541C1.26068 18.6881 0 15.5915 0 12.2087C0 8.92192 1.12701 5.8897 3.17321 3.67016C5.24383 1.42438 8.08501 0.1875 11.1743 0.1875C13.4833 0.1875 15.5978 0.917479 17.4591 2.35699C18.3984 3.08361 19.2498 3.97289 20 5.01018C20.7504 3.97289 21.6015 3.08361 22.5412 2.35699C24.4024 0.917479 26.517 0.1875 28.8259 0.1875C31.9149 0.1875 34.7564 1.42438 36.827 3.67016C38.8732 5.8897 39.9999 8.92192 39.9999 12.2087C39.9999 15.5915 38.7396 18.6881 36.033 21.9538C33.6117 24.8756 30.1321 27.841 26.1029 31.2748C24.7259 32.4479 23.1655 33.7778 21.546 35.1941C21.1184 35.5683 20.5691 35.7746 20 35.7746ZM11.1743 2.53064C8.74724 2.53064 6.51763 3.49926 4.89562 5.25829C3.24951 7.04387 2.34283 9.51213 2.34283 12.2087C2.34283 15.0538 3.40026 17.5984 5.77117 20.4591C8.06273 23.2243 11.4712 26.1289 15.4178 29.4923L15.4251 29.4984C16.8048 30.6742 18.3688 32.0072 19.9966 33.4305C21.6342 32.0045 23.2006 30.6693 24.5831 29.4916C28.5293 26.1283 31.9375 23.2243 34.2291 20.4591C36.5997 17.5984 37.6571 15.0538 37.6571 12.2087C37.6571 9.51213 36.7504 7.04387 35.1043 5.25829C33.4826 3.49926 31.2527 2.53064 28.8259 2.53064C27.048 2.53064 25.4156 3.09582 23.9743 4.21032C22.6898 5.20397 21.795 6.46007 21.2704 7.33898C21.0006 7.79094 20.5258 8.06072 20 8.06072C19.4741 8.06072 18.9993 7.79094 18.7295 7.33898C18.2052 6.46007 17.3105 5.20397 16.0257 4.21032C14.5843 3.09582 12.9519 2.53064 11.1743 2.53064Z"
                        fill="#131516"
                        fillOpacity="0.8"
                      />
                    </svg>
                  </span>
                  My Wishlist
                </button>
              </div>
            </div>
            <div className="col-md-2">
              <div className="buttonTab">
                <button
                  type="button"
                  className={`btn btn-xlarge ${
                    setActive === 'ManageFinance' && 'active'
                  }`}
                  onClick={toggleTab}
                  id="ManageFinance"
                  data-value="ManageFinance"
                >
                  <span>
                    <svg
                      width="40"
                      height="32"
                      viewBox="0 0 40 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M39.2634 8.00841L20.4352 0.477158C20.1559 0.365361 19.8442 0.365361 19.5648 0.477158L0.736641 8.00841C0.291719 8.18638 0 8.61731 0 9.09645V30.435C0 31.0822 0.524687 31.6068 1.17188 31.6068H38.8281C39.4753 31.6068 40 31.0822 40 30.435V9.09645C40 8.61731 39.7083 8.18638 39.2634 8.00841ZM37.6562 29.2632H2.34375V17.1034L19.5648 23.9918C19.8441 24.1036 20.1558 24.1036 20.4352 23.9918L37.6562 17.1034V29.2632ZM28.8847 18.0878L24.3059 19.9193C24.3077 19.8682 24.3098 19.8171 24.3098 19.7658C24.3098 17.3893 22.3764 15.4558 19.9999 15.4558C17.6234 15.4558 15.69 17.3893 15.69 19.7658C15.69 19.817 15.6921 19.8682 15.694 19.9193L11.1152 18.0878C13.047 16.9904 14.4424 15.0548 14.8036 12.7788H25.1961C25.5574 15.0548 26.9529 16.9904 28.8847 18.0878ZM27.5837 12.7788H31.3802V16.5754C29.5052 16.1331 28.0259 14.6538 27.5837 12.7788ZM21.9662 19.7658C21.9662 20.2414 21.7996 20.6885 21.4933 21.0443L20 21.6416L18.5068 21.0443C18.2005 20.6884 18.0339 20.2414 18.0339 19.7658C18.0339 18.6816 18.9159 17.7996 20.0001 17.7996C21.0842 17.7996 21.9662 18.6816 21.9662 19.7658ZM8.61977 16.5754V12.7788H12.4163C11.9741 14.6538 10.4948 16.1331 8.61977 16.5754ZM37.6562 14.5791L33.724 16.152V11.6068C33.724 10.9597 33.1993 10.435 32.5521 10.435H7.44789C6.8007 10.435 6.27602 10.9597 6.27602 11.6068V16.152L2.34375 14.5791V9.88989L20 2.82739L37.6562 9.88989V14.5791Z"
                        fill="#131516"
                        fillOpacity="0.75"
                      />
                    </svg>
                  </span>
                  Manage Finance
                </button>
              </div>
            </div>
            <div className="col-md-2">
              <div className="buttonTab">
                <button
                  type="button"
                  className={`btn btn-xlarge ${
                    setActive === 'MyProfile' && 'active'
                  }`}
                  onClick={toggleTab}
                  id="MyProfile"
                  data-value="MyProfile"
                >
                  <span>
                    <svg
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M19.7145 19.2682C22.3616 19.2682 24.6534 18.3188 26.5266 16.4456C28.3992 14.5728 29.3489 12.2812 29.3489 9.63379C29.3489 6.9873 28.3995 4.69543 26.5263 2.82196C24.6531 0.949402 22.3613 0 19.7145 0C17.0671 0 14.7755 0.949402 12.9026 2.82227C11.0298 4.69513 10.0801 6.987 10.0801 9.63379C10.0801 12.2812 11.0298 14.5731 12.9026 16.4459C14.7761 18.3185 17.068 19.2682 19.7145 19.2682ZM14.5604 4.47968C15.9974 3.0426 17.6832 2.34406 19.7145 2.34406C21.7454 2.34406 23.4315 3.0426 24.8689 4.47968C26.306 5.91705 27.0048 7.60315 27.0048 9.63379C27.0048 11.665 26.306 13.3508 24.8689 14.7882C23.4315 16.2256 21.7454 16.9241 19.7145 16.9241C17.6838 16.9241 15.998 16.2253 14.5604 14.7882C13.123 13.3511 12.4241 11.665 12.4241 9.63379C12.4241 7.60315 13.123 5.91705 14.5604 4.47968Z"
                        fill="#131516"
                        fillOpacity="0.8"
                      />
                      <path
                        d="M36.5726 30.758C36.5186 29.9786 36.4093 29.1284 36.2485 28.2305C36.0861 27.326 35.8771 26.4709 35.6268 25.6893C35.368 24.8815 35.0168 24.0838 34.5819 23.3193C34.1312 22.5259 33.6014 21.835 33.0069 21.2664C32.3853 20.6716 31.6241 20.1934 30.744 19.8446C29.8669 19.4976 28.895 19.3218 27.8552 19.3218C27.4469 19.3218 27.052 19.4894 26.2894 19.9859C25.82 20.292 25.271 20.646 24.6582 21.0375C24.1342 21.3714 23.4244 21.6842 22.5476 21.9674C21.6922 22.2442 20.8237 22.3846 19.9661 22.3846C19.1092 22.3846 18.2407 22.2442 17.3846 21.9674C16.5088 21.6845 15.7986 21.3717 15.2756 21.0378C14.6686 20.65 14.1193 20.296 13.6429 19.9856C12.8809 19.4891 12.486 19.3215 12.0776 19.3215C11.0376 19.3215 10.0659 19.4976 9.18915 19.8449C8.30963 20.1931 7.54822 20.6713 6.92596 21.2667C6.33148 21.8356 5.8017 22.5262 5.35126 23.3193C4.91699 24.0838 4.56543 24.8812 4.30664 25.6896C4.0567 26.4712 3.84766 27.326 3.6853 28.2305C3.52417 29.1271 3.41522 29.9777 3.36121 30.7589C3.30811 31.5228 3.28125 32.3177 3.28125 33.121C3.28125 35.209 3.94501 36.8994 5.25391 38.146C6.54663 39.3762 8.25684 39.9999 10.3372 39.9999H29.5975C31.6772 39.9999 33.3875 39.3762 34.6805 38.146C35.9897 36.9003 36.6534 35.2093 36.6534 33.1207C36.6531 32.3147 36.626 31.5197 36.5726 30.758ZM33.0643 36.4477C32.2101 37.2607 31.076 37.6559 29.5972 37.6559H10.3372C8.85803 37.6559 7.724 37.2607 6.87012 36.448C6.03241 35.6506 5.62531 34.562 5.62531 33.121C5.62531 32.3715 5.65002 31.6314 5.69946 30.921C5.74768 30.2239 5.84625 29.4583 5.99243 28.6447C6.13678 27.8411 6.3205 27.087 6.539 26.4044C6.74866 25.7498 7.03461 25.1016 7.38922 24.4772C7.72766 23.8821 8.11707 23.3715 8.54675 22.9601C8.94867 22.5753 9.45526 22.2604 10.0522 22.0242C10.6042 21.8057 11.2247 21.686 11.8982 21.668C11.9803 21.7117 12.1265 21.795 12.3633 21.9494C12.8452 22.2634 13.4006 22.6217 14.0146 23.0139C14.7067 23.4551 15.5984 23.8537 16.6638 24.1976C17.753 24.5498 18.8638 24.7286 19.9664 24.7286C21.069 24.7286 22.1802 24.5498 23.2687 24.1979C24.335 23.8534 25.2264 23.4551 25.9195 23.0132C26.5479 22.6116 27.0877 22.2637 27.5696 21.9494C27.8064 21.7953 27.9526 21.7117 28.0347 21.668C28.7085 21.686 29.3289 21.8057 29.8813 22.0242C30.4779 22.2604 30.9845 22.5756 31.3864 22.9601C31.8161 23.3712 32.2055 23.8818 32.5439 24.4775C32.8989 25.1016 33.1851 25.7501 33.3945 26.4041C33.6133 27.0876 33.7973 27.8414 33.9413 28.6443C34.0872 29.4595 34.1861 30.2255 34.2343 30.9213V30.9219C34.2841 31.6296 34.3091 32.3693 34.3094 33.121C34.3091 34.5623 33.902 35.6506 33.0643 36.4477Z"
                        fill="#131516"
                        fillOpacity="0.8"
                      />
                    </svg>
                  </span>
                  My Profile
                </button>
              </div>
            </div>
            <div className="col-md-2">
              <div className="buttonTab">
                <button
                  type="button"
                  className={`btn btn-xlarge ${
                    setActive === 'MyHomeServices' && 'active'
                  }`}
                  onClick={(e) => {
                    e.preventDefault();
                    // window.location.href='dashboard/homeservices';
                    // this.props.history.push("/dashboard/homeservices");
                    history.push('/dashboard/myhomeservices');
                  }}
                  id="MyProperties"
                  data-value="MyHomeServices"
                >
                  <span>
                    <svg
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M39.0001 17.32C38.9988 17.3191 38.9979 17.3178 38.997 17.3169L22.6801 1.00067C21.9846 0.304871 21.06 -0.078125 20.0764 -0.078125C19.0928 -0.078125 18.1681 0.304871 17.4723 1.00067L1.16398 17.3087C1.15849 17.3142 1.15269 17.32 1.1475 17.3255C-0.280721 18.7619 -0.27828 21.0926 1.15452 22.5254C1.80913 23.1803 2.67339 23.5593 3.59777 23.5993C3.63561 23.603 3.67345 23.6048 3.7116 23.6048H4.36162V35.6123C4.36162 37.9887 6.29522 39.922 8.67163 39.922H15.0553C15.7026 39.922 16.2272 39.3971 16.2272 38.7501V29.336C16.2272 28.2517 17.1094 27.3697 18.1937 27.3697H21.959C23.0433 27.3697 23.9253 28.2517 23.9253 29.336V38.7501C23.9253 39.3971 24.4499 39.922 25.0971 39.922H31.4808C33.8575 39.922 35.7908 37.9887 35.7908 35.6123V23.6048H36.3938C37.3771 23.6048 38.3018 23.2218 38.9979 22.5257C40.4322 21.0907 40.4329 18.7558 39.0001 17.32ZM37.3405 20.8686C37.0875 21.1216 36.7512 21.261 36.3938 21.261H34.6189C33.9717 21.261 33.4471 21.7856 33.4471 22.4329V35.6123C33.4471 36.6962 32.5651 37.5782 31.4808 37.5782H26.269V29.336C26.269 26.9596 24.3357 25.026 21.959 25.026H18.1937C15.817 25.026 13.8834 26.9596 13.8834 29.336V37.5782H8.67163C7.58764 37.5782 6.70538 36.6962 6.70538 35.6123V22.4329C6.70538 21.7856 6.18078 21.261 5.5335 21.261H3.78911C3.7708 21.2598 3.75279 21.2589 3.73418 21.2586C3.38506 21.2525 3.0576 21.1139 2.81224 20.8683C2.29039 20.3464 2.29039 19.4971 2.81224 18.975C2.81255 18.975 2.81255 18.9746 2.81285 18.9743L2.81377 18.9734L19.13 2.65778C19.3827 2.40479 19.7187 2.26563 20.0764 2.26563C20.4337 2.26563 20.7697 2.40479 21.0227 2.65778L37.3353 18.9701C37.3378 18.9725 37.3405 18.975 37.3429 18.9774C37.8621 19.5002 37.8611 20.3476 37.3405 20.8686Z"
                        fill="#131516"
                      />
                    </svg>
                  </span>
                  Home Services
                </button>
              </div>
            </div>
            <div className="col-md-2">
              <div className="buttonTab">
                <button
                  type="button"
                  className={`btn btn-xlarge ${
                    setActive === 'MyAdverts' && 'active'
                  }`}
                  onClick={toggleTab}
                  id="MyWishlist"
                  data-value="MyAdverts"
                >
                  <span>
                    <svg
                      width="40"
                      height="36"
                      viewBox="0 0 40 36"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M20 35.7746C19.4305 35.7746 18.8815 35.5683 18.4536 35.1935C16.8377 33.7806 15.2798 32.4528 13.9053 31.2815L13.8983 31.2754C9.86845 27.8413 6.38854 24.8756 3.96728 21.9541C1.26068 18.6881 0 15.5915 0 12.2087C0 8.92192 1.12701 5.8897 3.17321 3.67016C5.24383 1.42438 8.08501 0.1875 11.1743 0.1875C13.4833 0.1875 15.5978 0.917479 17.4591 2.35699C18.3984 3.08361 19.2498 3.97289 20 5.01018C20.7504 3.97289 21.6015 3.08361 22.5412 2.35699C24.4024 0.917479 26.517 0.1875 28.8259 0.1875C31.9149 0.1875 34.7564 1.42438 36.827 3.67016C38.8732 5.8897 39.9999 8.92192 39.9999 12.2087C39.9999 15.5915 38.7396 18.6881 36.033 21.9538C33.6117 24.8756 30.1321 27.841 26.1029 31.2748C24.7259 32.4479 23.1655 33.7778 21.546 35.1941C21.1184 35.5683 20.5691 35.7746 20 35.7746ZM11.1743 2.53064C8.74724 2.53064 6.51763 3.49926 4.89562 5.25829C3.24951 7.04387 2.34283 9.51213 2.34283 12.2087C2.34283 15.0538 3.40026 17.5984 5.77117 20.4591C8.06273 23.2243 11.4712 26.1289 15.4178 29.4923L15.4251 29.4984C16.8048 30.6742 18.3688 32.0072 19.9966 33.4305C21.6342 32.0045 23.2006 30.6693 24.5831 29.4916C28.5293 26.1283 31.9375 23.2243 34.2291 20.4591C36.5997 17.5984 37.6571 15.0538 37.6571 12.2087C37.6571 9.51213 36.7504 7.04387 35.1043 5.25829C33.4826 3.49926 31.2527 2.53064 28.8259 2.53064C27.048 2.53064 25.4156 3.09582 23.9743 4.21032C22.6898 5.20397 21.795 6.46007 21.2704 7.33898C21.0006 7.79094 20.5258 8.06072 20 8.06072C19.4741 8.06072 18.9993 7.79094 18.7295 7.33898C18.2052 6.46007 17.3105 5.20397 16.0257 4.21032C14.5843 3.09582 12.9519 2.53064 11.1743 2.53064Z"
                        fill="#131516"
                        fillOpacity="0.8"
                      />
                    </svg>
                  </span>
                  My Adverts
                </button>
              </div>
            </div>
          </div>
        </div>
        {setActive === 'MyProperties' && <MyProperties />}
        {setActive === 'MyWishlist' && <MyWishlist />}
        {setActive === 'ManageFinance' && (
          <div className="userdashboard-tabcontent">
            {/*            <div className="paymentoptions-card">
              <h1>PAYMENT OPTIONS</h1>
              <p>
                As the downturn from coronavirus pandemic squeezes the economy,
                higher-end and luxury real estate markets have become the hardest
                hit, as premium apartments property owners record lowest sales in
                major cities. In the past five years, high vacancy rate has existed
                in the luxury segment of the market, especially in Abuja, Lagos and
                Port Harcourt.
              </p>
              <Link to="/dashboard/paymentoptions" className="btn btn-danger br-0">
                CHECK OPTIONS
              </Link>
            </div> */}
            <div className="row">
              <div className="col-md-6">
                <div className="paymentcalculator-card">
                  <h1>AFFORDABILITY CALCULATOR</h1>
                  <p>
                    As the downturn from coronavirus pandemic squeezes the economy,
                    higher-end and luxury real estate markets have become the hardest
                    hit, as premium apartments property owners record lowest sales in
                    major cities. In the past five years, high vacancy rate has
                    existed in the luxury segment of the market, especially in Abuja,
                    Lagos and Port Harcourt.
                  </p>
                  <button
                    type="button"
                    className="btn btn-danger br-0"
                    onClick={() => history.push('/finance/affordability')}
                  >
                    CALCULATE
                  </button>
                </div>
              </div>
              {/*              <div className="col-md-6">
                <div className="paymentcalculator-card">
                  <h1>MY PAYMENT PROFILE</h1>
                  <p>
                    As the downturn from coronavirus pandemic squeezes the economy,
                    higher-end and luxury real estate markets have become the hardest
                    hit, as premium apartments property owners record lowest sales in
                    major cities. In the past five years, high vacancy rate has
                    existed in the luxury segment of the market, especially in Abuja,
                    Lagos and Port Harcourt.
                  </p>
                  <Link to="finance/paymentprofile" className="btn btn-danger br-0">
                    CHECK PROFILE
                  </Link>
                </div>
              </div> */}
            </div>
          </div>
        )}
        {setActive === 'MyProfile' && <UserProfile />}
      </div>
      <Footer />
    </section>
  );
};

export default UserDashboardPage;
